export class Questionnarie {
    constructor(public data?: {
        ID?: Number
        GroupID?: Number,
        Caption?: String,
        Filename?: String
    }) { }
}